import { useState, useEffect, createContext, useContext } from 'react'

/* ── Context partagé avec la Navbar ── */
export const PWAContext = createContext(null)

export function usePWA() {
  return useContext(PWAContext)
}

export function PWAProvider({ children }) {
  const [prompt,      setPrompt]      = useState(null)
  const [isIOS,       setIsIOS]       = useState(false)
  const [installable, setInstallable] = useState(false)
  const [installed,   setInstalled]   = useState(false)

  useEffect(() => {
    /* Déjà installé */
    if (
      window.matchMedia('(display-mode: standalone)').matches ||
      window.navigator.standalone === true
    ) {
      setInstalled(true)
      return
    }

    /* iOS Safari */
    const ua  = navigator.userAgent
    const ios = /iPad|iPhone|iPod/.test(ua) && !window.MSStream
    const safari = /^((?!chrome|android).)*safari/i.test(ua)
    if (ios && safari) {
      setIsIOS(true)
      setInstallable(true)
    }

    /* Android / Chrome / Desktop */
    const handler = (e) => {
      e.preventDefault()
      setPrompt(e)
      setInstallable(true)
    }
    window.addEventListener('beforeinstallprompt', handler)
    window.addEventListener('appinstalled', () => {
      setInstalled(true)
      setInstallable(false)
    })

    return () => window.removeEventListener('beforeinstallprompt', handler)
  }, [])

  const install = async () => {
    if (prompt) {
      prompt.prompt()
      const { outcome } = await prompt.userChoice
      if (outcome === 'accepted') {
        setInstalled(true)
        setInstallable(false)
      }
      setPrompt(null)
    }
  }

  return (
    <PWAContext.Provider value={{ installable, installed, isIOS, install }}>
      {children}
    </PWAContext.Provider>
  )
}
